<template>
  <div v-if="tags && tags.length">
    <div class="filter-group">
      <button
        class="filter-group__header"
        @click.prevent="visible = !visible"
      >
        <h3 class="filter-group__title">
          {{ this.$i18n.tags }}
        </h3>
        <div class="filter-group__icon">
          <img
            src="/themes/base/app/img/icon-chevron-down.svg"
            alt="Chevron"
            :style="
              visible == true
                ? { transform: 'rotate(180deg)' }
                : { transform: 'rotate(0)' }
            "
          />
        </div>
      </button>
      <transition
        name="accordion"
        @before-enter="beforeEnter"
        @enter="enter"
        @before-leave="beforeLeave"
        @leave="leave"
      >
        <div
          v-show="visible"
          class="filter-group__list"
        >
          <label
            v-for="tag in tags"
            :key="tag.term_id"
            :tag="tag"
            class="field-wrap"
          >
            <div class="checkbox">
              <input
                :id="tag.slug"
                v-model="filters.tags"
                type="checkbox"
                :value="tag.term_id"
              />
              <div class="checkbox__box"></div>
            </div>
            <span>{{ tag.name }}</span>
          </label>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filters: {
        tags: []
      },
      visible: true
    };
  },
  computed: {
    tags() {
      return this.$store.getters.tags;
    }
  },
  watch: {
    filters: {
      deep: true,
      handler(filters) {
        let query = Object.assign({}, this.$route.query);

        if (filters.tags && filters.tags.length) {
          query.page = 1;
          query.tags = JSON.stringify(filters.tags);

          this.$router
            .push({
              name: "Catalog",
              query
            })
            .catch(err => {});
        } else {
          delete query.tags;

          this.$router
            .replace({
              name: "Catalog",
              query
            })
            .catch(err => {});
        }
      }
    },
    "$route.query": {
      deep: true,
      handler(query) {
        if (!query.tags) {
          this.filters.tags = [];
        }
      }
    }
  },
  created() {
    let query = this.$route.query;
    if (query.tags && query.tags.length) {
      this.filters.tags = JSON.parse(query.tags);
    }
  },
  methods: {
    beforeEnter: function(el) {
      el.style.height = "0";
    },
    enter: function(el) {
      el.style.height = el.scrollHeight + "px";
    },
    beforeLeave: function(el) {
      el.style.height = el.scrollHeight + "px";
    },
    leave: function(el) {
      el.style.height = "0";
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/filter/Tags.vue